import { useStore } from 'reactflow';
import { FlowStartCardCombinedProps } from './types';

const usePresenter = (props: FlowStartCardCombinedProps): FlowStartCardCombinedProps => {
  return props;
};

export default usePresenter;
